import { Application } from "@hotwired/stimulus"

import Dialog from "./controllers/dialog_controller"
import Menu from "./controllers/menu_controller"
import Reveal from "./controllers/reveal_controller"
import Slider from "./controllers/slider_controller"

window.Stimulus = Application.start()
Stimulus.register('dialog', Dialog)
Stimulus.register('menu', Menu)
Stimulus.register('reveal', Reveal)
Stimulus.register('slider', Slider)
